/**
 * Retrieves the host for the GraphQL endpoint based on the environment.
 * - If the environment is 'localhost', it attempts to get the host from the URL query parameters.
 * - If not found in the query parameters, it checks local storage.
 * - If still not found, it uses a default host from settings.
 * - For non-localhost environments, it returns the host from the current window location.
 *
 * @param {EnvironmentDetailsResponse["environment"]} environment - The environment in which the app is running.
 * @returns {string | null} - The host for the GraphQL endpoint.
 */
export const getHostFromURL = (environment, urlHost) => {
    var _a;
    if (environment === "localhost") {
        // Get the 'host' parameter from the URL query string
        const params = new URLSearchParams(window.location.search);
        const hostParam = params.get("host");
        // Check if there is already a host saved in local storage
        const hasLocalStorageHost = localStorage.getItem("host");
        // If the 'host' parameter exists in the URL and there's no host in local storage, save it to local storage
        if (hostParam && !hasLocalStorageHost) {
            localStorage.setItem("host", hostParam);
        }
        // Return the 'host' parameter if it exists, otherwise return the host from local storage or the default settings
        return hostParam ? hostParam : (_a = localStorage.getItem("host")) !== null && _a !== void 0 ? _a : urlHost;
    }
    // For non-localhost environments, return the host from the current window location
    return window.location.host;
};
